export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="12" fill="#D97706" />
    <path
      fill="#FDFBF7"
      d="M31.5 8.5c-5.2 0-9.5 4.3-9.5 9.5 0 1.1.2 2.2.5 3.2l-9.3 9.3c-.9-.5-2.1-.4-3 .3-1.2.9-1.5 2.5-.7 3.8-.9 1.2-.7 2.9.5 3.9 1.1 1 2.7 1.1 3.9.3 1.3.8 3 .5 3.9-.7.7-.9.8-2.1.3-3l9.3-9.3c1 .3 2.1.5 3.2.5 5.2 0 9.5-4.3 9.5-9.5s-4.4-8.3-8.7-8.3z"
    />
    <circle cx="30.5" cy="17" r="2.4" fill="#D97706" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span
        className={`font-heading text-lg font-extrabold tracking-tight ${
          dark ? "text-canvas" : "text-charcoal"
        }`}
      >
        Bu Iyin
      </span>
      <span className="font-mono text-[10px] font-medium uppercase tracking-[0.22em] text-bumbu">
        Ayam Goreng Bandung
      </span>
    </span>
  </span>
);
